import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSquare, faBookmark } from '@fortawesome/free-solid-svg-icons';
import { stickerSet }  from '../../store/stickerSlice';
import useApi from '../../hooks/useApi';
//
// Компонент выводит список стикеров мероприятия
//
const EventStickersList = ({ event }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ event: event._id });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/stickers', params });

    const onClick = (sticker) => {
        dispatch(stickerSet(sticker));
        navigate('/cabinet/stickeredit');
    };

	return (
    <div>
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <div>{t('loader.title')}</div>}

        <h2>
            {t('eventview.stickers')}
            <span onClick={() => navigate('/cabinet/stickeradd')}>{t('common.add')}</span>
        </h2>

        {data && <React.Fragment>
            {data.stickers.length < 1 ? <div>{t('eventview.nostickers')}</div> :
                <ul>
                {data.stickers.map(item => (
                    <li
                        key={item._id}
                        onClick={() => onClick(item)}
                    >
                        <span className='fa-stack small'>
                            <Icon icon={faSquare} className='fa-stack-2x' style={{ color: item.background }}/>
                            <Icon icon={faBookmark} className='fa-stack-1x' style={{ color: item.color }}/>
                        </span>
                        <span className='a'>{item.text[lang]}</span>&nbsp;
                        <span style={{color:'var(--gray-color)'}} className='small'>({item.priority})</span>
                    </li>
                ))}
                </ul>}
        </React.Fragment>}

    </div>
	);
};

EventStickersList.propTypes = {
    event: PropTypes.object.isRequired,
};

export default EventStickersList;
